import Entity from "./Entity";

export default class MapLayer extends Entity {
    constructor(data) {
        super(data);

        this.attributeKeys = [
            "id", "title", "hideable", "hidden", "forMapObjectStatus", "forMapObjectLabelMarker", "forMapObjectDistanceMarker", "linkedMapObjectLayerId"
        ];
    }

    get visible() {
        return !this.hidden;
    }

    set visible(value) {
        if (!value != this.hidden) {
            this.hidden = !value;

            for (var subscriber of this.subscribers) {
                subscriber.next({ 
                    field: "hidden",
                    value: this.hidden
                });
            }
        }
    }
}